var CookieChecker = /** @class */ (function () {
    function CookieChecker(listenCookie, onCookieSet) {
        this.lastCookie = document.cookie;
        this.listenCookie = listenCookie;
        this.onCookieSet = onCookieSet;
        this.runnerId = undefined;
    }
    CookieChecker.prototype.run = function () {
        var _this = this;
        if (this.listenCookie()) {
            this.onCookieSet();
        }
        else {
            var checkCookie = function () {
                var currentCookie = document.cookie;
                if (currentCookie !== _this.lastCookie) {
                    if (_this.listenCookie()) {
                        _this.onCookieSet();
                        _this.stop();
                    }
                    _this.lastCookie = currentCookie; // store latest cookie
                }
            };
            this.runnerId = setInterval(checkCookie, 100);
        }
    };
    CookieChecker.prototype.stop = function () {
        if (this.runnerId) {
            clearInterval(this.runnerId);
        }
    };
    return CookieChecker;
}());
export { CookieChecker };
